module.exports = __webpack_public_path__ + "img/member2.ccb208e.jpg";